const appConfig = {
  version: '2.0.2'
};

export default appConfig;
